export default __webpack_public_path__ + "static/media/Download_on_the_Appstore.8c4986ee.svg";